import { interpolateStringUtil } from '@gymaholic/packages/src/utils/string/interpolate'
import saveReduxAction from 'modules/redux/actions/save'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import {
  TRAINING_USERS_DOMAIN,
  TRAINING_USERS_ENDPOINT
} from 'modules/training/modules/training-users/constants'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import { logUtil } from 'packages/src'

export default function saveTrainingUserAction (props = {}) {
  return async (dispatch, getState) => {
    const { options } = props
    const logName = 'saveTrainingUserAction'
    const trainingUser = getCurrentTrainingUserSelect(getState())
    if (!trainingUser) {
      return
    }
    const id = getIdReduxUtil(trainingUser)
    const logPrefix = `user.id=${id}`
    try {
      const path = getPathReduxUtil(trainingUser, TRAINING_USERS_DOMAIN)
      const endpoint = `${getEndpointTrainingUtil(interpolateStringUtil(TRAINING_USERS_ENDPOINT.BY_ID, { id }))}`
      const debugProps = {
        endpoint,
        path,
        props
      }
      logUtil(logName).debug(`${logPrefix} [start] debugProps=`, debugProps)
      dispatch(
        saveReduxAction({
          type: 'USER_SAVE',
          payload: {
            path,
            endpoint,
            domainPath: TRAINING_USERS_DOMAIN,
            options
          }
        })
      )
    } catch (error) {
      logUtil(logName).debug(`${logPrefix} error=`, error)
    }
  }
}
